import { Link, useNavigate } from "react-router-dom";
import ArcButton, { ButtonColor, ButtonIcon, ButtonType } from "app/components/arc/ArcButton";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div id="wrap">
      <header id="header">
        <div className="header-wrap">
          <h1 className="logo">
            <Link to="/" title="홈 화면으로 이동">
              <span className="hid">ENERUSE</span>
            </Link>
          </h1>
        </div>
      </header>

      <div id="container">
        <div id="sub_container">
          <div id="contents">
            <div className="container">
              <div className="auth-page-wrapper py-5 d-flex justify-content-center align-items-center min-vh-100">
                <div className="auth-page-content overflow-hidden p-0">
                  <div className="container">
                    <div className="row justify-content-center">
                      <div className="col-xl-7 col-lg-8">
                        <div className="text-center">
                          <img src="/portal/assets/img/sub/error400-cover.png" alt="404 error img"
                               className="img-fluid"></img>
                          <div className="mt-3">
                            <h3 className="text-uppercase">페이지를 찾을 수 없습니다.</h3>
                            <p className="text-muted mb-4">페이지의 URL을 확인해주세요.</p>

                            <ArcButton
                              type={ButtonType.custom}
                              color={ButtonColor.btn1}
                              hasIcon={true}
                              icon={ButtonIcon.home}
                              text="홈으로"
                              onClick={() => navigate('/', { replace: true })}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
